import { combineReducers, configureStore } from "@reduxjs/toolkit";
import fcmReducer from "../features/fcmSlice";

const rootReducer = combineReducers({
  fcmToken: fcmReducer,
});

export function setupStore(preloadedState) {
  return configureStore({
    reducer: rootReducer,
    preloadedState,
  });
}

export default configureStore({
  reducer: fcmReducer,
});
